window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.glightbox').length) {
    import('./_lightbox.js').then((module) => {
      module.Init();
    });
  }
});
  
export default {}